module.exports = __webpack_public_path__ + "images/liinilaevad/apple-icon-76x76.png";